import md5 from 'md5';

export default function (str = '') {
    const s = str.toLowerCase();

    return md5(s);
}
